import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import React, { useMemo } from "react";
import styled, { css } from "styled-components";
import { useNextRouterContext } from "@faire/retailer/app/_lib/routing/NextRouterContext";
import { AccessibilityAnchor, AccessibilityLink } from "@faire/retailer-visitor-shared/lib/AccessibilityLink";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { useAssignSettingLoggedInHomePageRouteChangePrefetching, useSettingLoggedInHomePageRouteChangePrefetching } from "@faire/retailer/settings/useSettingLoggedInHomePageRouteChangePrefetching";
import { useHeaderDesktopContent } from "./useHeaderDesktopContent";
export var HeaderDesktopLogo = function(param) {
    var omitStyling = param.omitStyling;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isFaireDirectActiveInLoggedOut = useHeaderDesktopContent().isFaireDirectActiveInLoggedOut;
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    var accessibleLogoLabel = strictLocalize({
        id: "CA6lm2",
        defaultMessage: [
            {
                type: 0,
                value: "Go to Faire homepage"
            }
        ]
    });
    var isLoggedInHomePageRouteChangePrefetching = useSettingLoggedInHomePageRouteChangePrefetching();
    var assignSettingLoggedInHomePageRouteChangePrefetching = useAssignSettingLoggedInHomePageRouteChangePrefetching();
    var onLogoHover = useMemo(function() {
        return function() {
            nextPrefetch(isFaireDirectActiveInLoggedOut ? faireBaseUrl() : home(), {
                kind: isLoggedInHomePageRouteChangePrefetching ? PrefetchKind.FULL : PrefetchKind.AUTO
            });
        };
    }, [
        nextPrefetch,
        isFaireDirectActiveInLoggedOut,
        isLoggedInHomePageRouteChangePrefetching
    ]);
    var onLogoClick = useMemo(function() {
        return function() {
            return assignSettingLoggedInHomePageRouteChangePrefetching();
        };
    }, [
        assignSettingLoggedInHomePageRouteChangePrefetching
    ]);
    var sharedProps = {
        id: "faire-logo-link",
        "aria-label": accessibleLogoLabel,
        onMouseEnter: onLogoHover,
        onTouchStart: onLogoHover,
        onClick: onLogoClick
    };
    if (isFaireDirectActiveInLoggedOut) {
        return /*#__PURE__*/ _jsx(LogoAnchor, _object_spread_props(_object_spread({
            href: faireBaseUrl()
        }, sharedProps), {
            children: /*#__PURE__*/ _jsx(FaireLogo, {})
        }));
    }
    if (omitStyling) {
        return /*#__PURE__*/ _jsx(AccessibilityLink, _object_spread_props(_object_spread({
            to: home()
        }, sharedProps), {
            children: /*#__PURE__*/ _jsx(FaireLogo, {})
        }));
    }
    return /*#__PURE__*/ _jsx(LogoLink, _object_spread_props(_object_spread({
        to: home()
    }, sharedProps), {
        children: /*#__PURE__*/ _jsx(FaireLogo, {})
    }));
};
var LogoStyling = css([
    "padding:",
    ";margin:0 ",
    ";"
], getSpacing("1x", "2x"), getSpacing("1x"));
var LogoAnchor = styled(AccessibilityAnchor).withConfig({
    componentId: "sc-95b25268-0"
})([
    "",
    ""
], LogoStyling);
var LogoLink = styled(AccessibilityLink).withConfig({
    componentId: "sc-95b25268-1"
})([
    "",
    ""
], LogoStyling);
